export const MenuItems = [
    {
        title : "Home",
        url : "/",
        cName : "nav-links",
        icon : "fa-solid fa-house"
    },
    {
        title : "About",
        url : "/about",
        cName : "nav-links",
        icon : "fa-solid fa-user"
    },
    {
        title : "Gallery",
        url : "/",
        cName : "nav-links",
        icon : "fa-solid fa-image"
    },
    {
        title : "Contact",
        url : "/contact",
        cName : "nav-links",
        icon : "fa-solid fa-address-book"
    },
    {
        title : "Sign Up",
        url : "/signup",
        cName : "nav-links-mobile",
    }
]